export const GENERAL_ERROR = "Something Went Wrong";
